import { useCallback, useState } from 'react';
import { EventSections } from '../lib/events/EventLogger';
import { SvgActions } from '@parcel2go/core-ui';
import { P2GSidePanel } from '~/components/sidepanel';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import { GenerateBaseAnalyticsPayload } from '~/lib/utils/analytics';
import ActionMenuContent from './smartsend/sidepanel/action-menu-content';
import CdnIconProxy from '~/apps/account-linking/components/CdnIconProxy';
import ChatButton from './ChatButton';
import useSmartSendAnalytics from '~/hooks/use-smartsend-analytics';

export interface props {
  isXs: boolean;
  currentPageRoute: string;
}

const ActionMenu: React.FC<props> = ({ currentPageRoute, isXs }) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const [open, setOpen] = useState(false);
  const { track } = useSmartSendAnalytics();

  const logEvent = useCallback(
    (link: string, close?: boolean) => {
      track({
        type: 'navigation_shortcut_used',
        payload: GenerateBaseAnalyticsPayload([EventSections.MyAccount, EventSections.QuickActions], {
          surface: 'quick-actions-menu',
          action: 'navigation-shortcut',
          link
        })
      });
      if (close !== undefined) {
        setOpen(!close);
      }
    },
    [track]
  );

  return (
    <>
      <CdnIconProxy
        onClick={() => setOpen(true)}
        classNames={'smartsend-quickmenu'}
        palette="primary"
        size="sm"
        src="/theme/icons/Actions.svg"
      >
        <SvgActions />
      </CdnIconProxy>
      <P2GSidePanel
        anchor="right"
        open={open}
        onClose={() => logEvent('close-button', true)}
        title={t('SIDEBAR_TITLE', { defaultValue: 'Quick Links' })}
        titleAdornment={
          <ChatButton
            onOpenChat={() => logEvent('LiveChat', true)}
            label={t('SIDEBAR_CHAT_BUTTON', { defaultValue: 'Support' })}
          />
        }
      >
        <ActionMenuContent
          logEvent={(l) => logEvent(l, isXs)}
          currentPageRoute={currentPageRoute}
          showFullMenuStructure={true}
        />
      </P2GSidePanel>
    </>
  );
};

export default ActionMenu;
